// src/features/interview/components/AlertPanel.jsx
import React from "react";
import { AlertTriangle } from "lucide-react";

const AlertPanel = ({ getActiveAlerts, alertLog, stickyAlertCount, isAlertPanelOpen, handleAlertIconClick, isAlertPanelOpenSetter, currentAlertIndex, navigateToPrevAlert, navigateToNextAlert, handleAlertClick }) => {
  const activeAlerts = getActiveAlerts();
  const currentAlert = activeAlerts[currentAlertIndex];
  const hasMultipleAlerts = activeAlerts.length > 1;

  return (
    <>
      {getActiveAlerts().length > 0 && (
        <div className="fixed bottom-6 left-6 z-50">
          <div
            className={`
            relative w-14 h-14 rounded-full cursor-pointer transition-all duration-300
            flex items-center justify-center shadow-lg hover:shadow-xl
            ${
              Object.values(alertLog).some((a) => a.glowing)
                ? "bg-gradient-to-r from-orange-500 to-yellow-500 alert-glow"
                : "bg-gray-700 hover:bg-gray-600"
            }
          `}
            style={{
              animation: Object.values(alertLog).some((a) => a.glowing)
                ? "pulse-glow 1.5s ease-in-out infinite"
                : "none",
            }}
            onClick={handleAlertIconClick}
          >
            <AlertTriangle
              className={`w-6 h-6 transition-colors duration-300 ${
                Object.values(alertLog).some((a) => a.glowing)
                  ? "text-white"
                  : "text-gray-300"
              }`}
            />
            {stickyAlertCount > 0 && (
              <div
                className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full 
              flex items-center justify-center shadow-md animate-pulse"
              >
                <span className="text-xs font-bold text-white">
                  {stickyAlertCount}
                </span>
              </div>
            )}
          </div>

          {isAlertPanelOpen && (
            <div className="absolute bottom-0 left-16 min-w-[280px] bg-gray-700 rounded-lg shadow-xl p-3">
              {activeAlerts.length > 0 ? (
                <div className="flex items-center justify-between">
                  {hasMultipleAlerts && currentAlertIndex > 0 && (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigateToPrevAlert();
                      }}
                      className="p-1 hover:bg-gray-700 rounded transition-colors"
                    >
                      <svg
                        className="w-4 h-4 text-gray-300"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 19l-7-7 7-7"
                        />
                      </svg>
                    </button>
                  )}

                  <div className="flex items-center justify-between flex-1 mx-2">
                    <span
                      className={`text-gray-300 text-sm font-medium ${
                        currentAlert?.isClickable ? "cursor-pointer hover:text-blue-400 underline" : ""
                      }`}
                      onClick={() => currentAlert?.isClickable && handleAlertClick(currentAlert.type)}
                    >
                      {currentAlert?.message}
                    </span>
                    {currentAlert?.type !== "fullscreen_exit" && (
                      <div className="w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center ml-3">
                        <span className="text-xs font-bold text-white">
                          {currentAlert?.count}
                        </span>
                      </div>
                    )}
                  </div>

                  {hasMultipleAlerts && currentAlertIndex < activeAlerts.length - 1 && (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigateToNextAlert();
                      }}
                      className="p-1 hover:bg-gray-700 rounded transition-colors"
                    >
                      <svg
                        className="w-4 h-4 text-gray-300"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </button>
                  )}
                </div>
              ) : (
                <span className="text-gray-400 text-sm">
                  No recent alerts
                </span>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default AlertPanel;
